import { IconButton, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import { trackFlagTargetingEvent } from '#utils/flags/flagAnalytics';

import styles from './PendingChangesModal.module.css';

interface SelectReviewersTriggerProps {
  setShowOptionalReviewers: (showOptionalReviewers: boolean) => void;
  showOptionalReviewers: boolean;
}

export function SelectReviewersTrigger({
  setShowOptionalReviewers,
  showOptionalReviewers,
}: SelectReviewersTriggerProps) {
  return showOptionalReviewers ? null : (
    <TooltipTrigger>
      <IconButton
        data-test-id="select-reviewers"
        aria-label="Select reviewers"
        className={styles.popoverTrigger}
        onPress={() => {
          setShowOptionalReviewers(!showOptionalReviewers);
          if (!showOptionalReviewers) {
            trackFlagTargetingEvent('Bypass Approvals Clicked');
          }
        }}
        icon="person-add"
      />
      <Tooltip>Select reviewers</Tooltip>
    </TooltipTrigger>
  );
}
